"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useStyles2 = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var VideoPaper = function VideoPaper(_ref) {
  var video = _ref.video;

  var _useStyles = (0, _useStyles2["default"])(),
      iframe = _useStyles.iframe,
      figcaption = _useStyles.figcaption,
      figure = _useStyles.figure;

  return /*#__PURE__*/_react["default"].createElement("figure", {
    className: figure
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    key: "18a9368c-56f7-4e5d-8aca-d05b5a788bad",
    className: iframe,
    title: "".concat(video.title, " - YouTube"),
    src: "//www.youtube.com/embed/".concat(video.id),
    frameBorder: "0",
    allowFullScreen: true
  }), video.caption && /*#__PURE__*/_react["default"].createElement("figcaption", {
    className: figcaption
  }, video.caption));
};

VideoPaper.defaultProps = {
  video: {}
};
VideoPaper.propTypes = {
  video: _propTypes["default"].shape({
    caption: _propTypes["default"].string,
    title: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string.isRequired
  })
};
var _default = VideoPaper;
exports["default"] = _default;